import { MetricTile, Skeleton } from "@skailer-com/uikit";
import { ReactNode } from "react";

type KpiFormat = "percent" | "integer" | "decimal1" | ((value: number) => string);

export interface KpiTileProps {
  title: string;
  titleIcon?: ReactNode;
  value: number | string | null | undefined;
  isLoading?: boolean;
  format?: KpiFormat;
  caption?: ReactNode;
  className?: string;
}

// API serializes Decimal as a JSON string, so values may arrive as strings — coerce before formatting.
const formatValue = (value: number | string | null | undefined, format?: KpiFormat): string => {
  if (typeof value === "string" && !format) return value;
  const safe = Number(value ?? 0);
  if (typeof format === "function") return format(safe);
  switch (format) {
    case "percent":
      return `${safe.toFixed(2)}%`;
    case "decimal1":
      return safe.toFixed(1);
    case "integer":
      return `${safe}`;
    default:
      return `${value ?? 0}`;
  }
};

export const KpiTile = ({
  title,
  titleIcon,
  value,
  isLoading,
  format,
  caption,
  className,
}: KpiTileProps) => {
  if (isLoading) {
    return <Skeleton className={className ?? "w-full h-20"} />;
  }
  return (
    <MetricTile
      className={className}
      title={title}
      titleIcon={titleIcon}
      value={formatValue(value, format)}
      caption={caption}
    />
  );
};
